import request from '@/utils/request'

/**
 * 未绑定指定客服的ERP业务成员分页查询
 */
export function erpUnboundPage(data) {
  return request({
    url: '/erp/customer/contact/unboundPage',
    method: 'post',
    data,
    params: { pageNum: data.pageNum || 1, pageSize: data.pageSize || 10 }
  })
}

/**
 * 已绑定指定客服的ERP业务成员分页查询
 */
export function erpBoundPage(data) {
  return request({
    url: '/erp/customer/contact/boundPage',
    method: 'post',
    data,
    params: { pageNum: data.pageNum || 1, pageSize: data.pageSize || 10 }
  })
}

/**
 * 绑定ERP业务成员与客服
 */
export function erpBind(data) {
  return request({ url: '/erp/customer/contact/user/bind', method: 'post', data })
}

/**
 * 取消绑定ERP业务成员与客服
 */
export function erpUnbind(data) {
  return request({ url: '/erp/customer/contact/user/unbind', method: 'post', data })
}
